/**
 * Central registry of optional tools that can be enabled per-user by admins.
 * Adding a new tool here + its `path` automatically:
 *   - Surfaces it in the Admin "Ferramentas" multi-select
 *   - Adds a sidebar shortcut when the user has it enabled
 *   - Renders inside `/app/ferramentas/:slug` as a full-viewport iframe
 *
 * Admins always have access to every tool regardless of `user.tools`.
 */
export const AVAILABLE_TOOLS = [
  {
    id: "proposta",
    label: "Criador de Propostas Comerciais",
    short: "Propostas",
    description:
      "Gestão de clientes, biblioteca de serviços e geração de propostas comerciais em PDF com identidade Sollute. Dados ficam salvos localmente no navegador (não sincronizados entre dispositivos).",
    icon: "fa-file-signature",
    htmlPath: "/tools/proposta.html",
  },
];

/** Returns the tools enabled for a given user (admins get all). */
export function userTools(user) {
  if (!user) return [];
  if (user.role === "admin") return AVAILABLE_TOOLS;
  const enabled = user.tools || [];
  return AVAILABLE_TOOLS.filter((t) => enabled.includes(t.id));
}

export function findTool(id) {
  return AVAILABLE_TOOLS.find((t) => t.id === id);
}
